import { SupportedLocalesEnum } from 'front-end/../types/SupportedLocalesEnum'
import { usePublicApiSession } from '../public-api/hooks/usePublicApiSession'

/**
 * Recognize language with Kanji letters (chinese and japonese)
 */
export const isLocaleWithKanjiLetters = () => {
  const { session } = usePublicApiSession()
  const locale = session?.user.locale

  return (
    locale === SupportedLocalesEnum.zhHans ||
    locale === SupportedLocalesEnum.zhHant
  )
}
